import { CatalogItem } from './catalogItem';

export class Catalog {
  id: string | undefined;
  merchantId: string | undefined;
  name: string | undefined;
  description: string | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  archived: boolean;
  items: CatalogItem[] = [];

  constructor(data: Partial<Catalog>) {
    this.id = data.id;
    this.merchantId = data.merchantId;
    this.name = data.name;
    this.description = data.description ?? '';
    this.createdAt = data.createdAt ?? new Date();
    this.updatedAt = data.updatedAt ?? new Date();
    this.archived = data.archived ?? false;
    this.items = data.items ?? [];
  }

  static createEmpty(): Partial<Catalog> {
    return new Catalog({
      id: '',
      merchantId: '',
      name: '',
      description: '',
      archived: false,
      createdAt: new Date(),
      updatedAt: new Date(),
      items: [],
    });
  }
}
